import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import MULink from '@mui/material/Link';

import Typography from '@ts-core/components/Typography';

import ThreadStats from './ThreadStats';
import ForumItemInfo from './ForumItemInfo';

const border = (theme) => `solid 1px ${theme.palette.grey[300]}`;

const useStyles = makeStyles((theme) => ({
  root: {
    borderTop: border(theme),
    '&:last-child': {
      borderBottom: border(theme),
    },
  },
  userName: {
    marginLeft: theme.spacing(1),
  },
}));

const ThreadListItem = (props) => {
  const classes = useStyles();
  const { loading, thread } = props;
  return (
    <Box
      py={{ xs: 1, md: 2 }}
      px={{ xs: 1, md: 3 }}
      className={classes.root}
      display="flex"
      flexDirection={{ xs: 'column', md: 'row' }}
      justifyContent="space-between"
    >
      <Box display="flex" flexDirection="column" justifyContent="flex-start">
        <MULink to={`forum/${thread._id}`} component={Link}>
          <Typography variant="subtitle1" loading={loading}>
            {thread?.title}
          </Typography>
        </MULink>
        <ForumItemInfo
          createdAt={thread?.createdAt}
          user={thread?.user}
          loading={loading}
        />
      </Box>
      <Box display="flex" justifyContent="flex-end" mt={{ xs: 1, md: 0 }}>
        <ThreadStats thread={thread} loading={loading} />
      </Box>
    </Box>
  );
};

ThreadListItem.propTypes = {
  loading: PropTypes.bool,
  thread: PropTypes.object,
};

ThreadListItem.defaultProps = {
  loading: false,
  thread: {},
};

export default ThreadListItem;
